/* global document */

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { useComponentWillMount } from 'common/helpers/hooks';
import { useLocalization } from 'redux/localization/utils/hooks';

import APIError from '../apiError/APIError';

const LoadingLayout = () => {
  const { t } = useLocalization();

  const handleMount = () => {
    const c7Content = document.getElementById('c7-content');
    c7Content.removeAttribute('style');
    const c7CheckoutContent = document.getElementById('c7-checkout-content');
    if (c7CheckoutContent) {
      c7CheckoutContent.parentNode.removeChild(c7CheckoutContent);
    }
    c7Content.style.minHeight = '100vh';
  };

  useComponentWillMount(handleMount);

  const apiError = useSelector((state) => state.apiError);

  useEffect(() => {
    if (apiError) {
      removeLoadingFromC7Content();
    }
  }, [apiError]);

  return (
    <section className="c7-content">
      <Helmet>
        <title>{t('general.accessibility.loading')}</title>
      </Helmet>
      <APIError position="layout" />
      &nbsp;
    </section>
  );
};

const removeLoadingFromC7Content = () => {
  const c7Content = document.getElementById('c7-content');
  c7Content.style.minHeight = 0;
};

export default LoadingLayout;
